export const MODULE_NAME = 'account activation'

export const MODULE_TITLE = 'Aktywacja konta'

export const paths = {
  root: '/activation',
}
